import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiMic, FiUsers, FiMail, FiSmartphone, FiSettings, FiShield } = FiIcons;

const FeaturesSection = () => {
  const features = [
    {
      icon: FiMic,
      title: 'HD Call Recording',
      description: 'Automatic call recording with secure cloud storage and easy retrieval for compliance and training.'
    },
    {
      icon: FiUsers,
      title: 'CRM Integration',
      description: 'Seamlessly connect with Salesforce, HubSpot, and other popular CRM systems for better customer insights.'
    },
    {
      icon: FiMail,
      title: 'Voicemail to Email',
      description: 'Receive voicemail transcriptions directly in your inbox with audio attachments for convenience.'
    },
    {
      icon: FiSmartphone,
      title: 'Mobile & Desktop Apps',
      description: 'Work from anywhere with feature-rich mobile and desktop applications that sync across all devices.'
    },
    {
      icon: FiSettings,
      title: 'Custom IVR Systems',
      description: 'Professional auto-attendants and call routing to ensure customers reach the right department quickly.'
    },
    {
      icon: FiShield,
      title: 'Enterprise Security',
      description: 'Bank-level encryption, secure SIP trunking, and compliance with HIPAA and government standards.'
    }
  ];

  return (
    <section id="features" className="py-20 bg-white">
      <div className="w-4/5 mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Everything Your Business Needs
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            3CX delivers enterprise-grade features at a fraction of the cost of traditional providers
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              className="bg-gray-50 p-8 rounded-xl hover:shadow-lg transition-shadow"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <div className="bg-primary-100 w-16 h-16 rounded-lg flex items-center justify-center mb-6">
                <SafeIcon icon={feature.icon} className="h-8 w-8 text-primary-600" />
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">
                {feature.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {feature.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;